import React from 'react';
import {constant} from 'lodash/fp';

import CoachesListHeader from '/component/partial/report/CoachesListHeader';
import CoachRank from '/component/partial/report/CoachRank';
import CoachSponsor from '/component/partial/report/CoachSponsor';
import PeopleReportDataRenderer from '/component/partial/report/PeopleReportDataRenderer';
import ReportDataProvider from '/component/partial/report/ReportDataProvider';

import {ReportProps} from '../Report.types';

import reportPayload from './reportPayload';

import {useRecordsSorting} from '/context/RecordsSort/useRecordsSorting';

export const NewOrganizationCoachesContent = ({
  loadingData = {total: 0},
  showRecordPopover = () => {},
  recordsShowPopover = () => {},
  recordsShowRecord = () => {},
}: ReportProps) => {
  const {isReadyToLoad, sortParam} = useRecordsSorting({
    recordsName: reportPayload.reportName,
  });

  if (!isReadyToLoad) {
    return null;
  }

  return (
    <ReportDataProvider
      {...reportPayload}
      dataRenderer={PeopleReportDataRenderer}
      dataRendererProps={{
        listHeaderComponent: CoachesListHeader,
        personRoleComponent: CoachRank,
        personInfoComponent: CoachSponsor,
        personIsCoach: constant(true),
        onRecordPress: ({id}: any) =>
          showRecordPopover([id], {recordsShowPopover, recordsShowRecord}),
      }}
      loadingData={loadingData}
      reportParams={[{...sortParam.params}]}
    />
  );
};
